import { existsSync, readFileSync, writeFileSync } from "node:fs";
import { join, resolve } from "node:path";

export const APP_CONFIG_FILENAME = "whop.app.json";

export type AppConfig = {
	app_id: string;
	name: string;
	route: string;
};

export function findProjectDir(startDir?: string): string | null {
	let dir = resolve(startDir ?? process.cwd());
	for (let i = 0; i < 25; i++) {
		if (existsSync(join(dir, APP_CONFIG_FILENAME))) return dir;
		const parent = resolve(dir, "..");
		if (parent === dir) break;
		dir = parent;
	}
	return null;
}

export function readAppConfig(projectDir: string): AppConfig | null {
	const path = join(projectDir, APP_CONFIG_FILENAME);
	if (!existsSync(path)) return null;
	try {
		const parsed = JSON.parse(
			readFileSync(path, "utf-8"),
		) as Partial<AppConfig>;
		if (
			typeof parsed.app_id === "string" &&
			typeof parsed.name === "string" &&
			typeof parsed.route === "string"
		) {
			return { app_id: parsed.app_id, name: parsed.name, route: parsed.route };
		}
		return null;
	} catch {
		return null;
	}
}

export function writeAppConfig(projectDir: string, config: AppConfig): void {
	writeFileSync(
		join(projectDir, APP_CONFIG_FILENAME),
		`${JSON.stringify(config, null, "\t")}\n`,
	);
}

export function slugify(name: string): string {
	return name
		.toLowerCase()
		.normalize("NFKD")
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "")
		.slice(0, 63);
}
